var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Индивидуальные условия "),_c('a',{attrs:{"href":_vm.uiUrl,"target":"_blank"}},[_vm._v("Открыть документ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }